import axios from 'axios';

export function sendPhoneNumber(phoneNumber: string) {
  return axios.post('/set_phone_number', {
    phoneNumber,
  });
}

export function sendVerificationCode(phoneNumber: string, code: string) {
  return axios.post('/set_phone_number', {
    phoneNumber,
    code,
  });
}

export async function signup(signupInfos: {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  position: string;
  jobTitle: string;
  firmSize: string;
  agreedToTerms: boolean;
}) {
  return (await axios.post('/signup', signupInfos)).data;
}

export function validateAutomaticSignup({
  password,
  agreedToTerms,
  verificationToken,
  firstName,
  lastName,
}: {
  password: string;
  agreedToTerms: boolean;
  verificationToken: string;
  firstName: string;
  lastName: string;
}) {
  return axios.post('/validate_api_signup', {
    password,
    agreedToTerms,
    verificationToken,
    firstName,
    lastName,
  });
}
